export default __webpack_public_path__ + "static/media/MM-Logomark-2C.99c1938b.png";